// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Bx_c","content":"styles_content__2jA4N"};